import React, { useState } from 'react';
import axios from 'axios';
import { APP_API_URL } from '../../utils';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import DuoModal from '../../components/ui/duo-modal';

export default function Add({ open, onClose, refreshData }) {
  const user = useSelector((state) => state.auth.user);
  const [formData, setFormData] = useState({
    titre: '',
    description: '',
    statut: true,
    user_id: user?.id,
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setLoading] = useState(false);

  if (!open) return null;

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const resetForm = () => {
    setFormData({ titre: '', description: '', statut: true, user_id: user?.id });
    setErrors({});
  };

  const handleClose = () => {
    resetForm();
    onClose();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(`${APP_API_URL}/postes`, formData, {
        headers: { Authorization: `Bearer ${token}` },
      });

      await Swal.fire({
        icon: 'success',
        title: 'Succès',
        text: response.data?.message || 'Le poste a été créé avec succès.',
        timer: 2000,
        showConfirmButton: false,
      });

      resetForm();
      onClose();
      refreshData();
    } catch (error) {
      if (error.response?.status === 422) {
        setErrors(error.response.data.errors);
        Swal.fire({
          icon: 'error',
          title: 'Erreur de validation',
          text: 'Veuillez vérifier les champs du formulaire.',
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Erreur',
          text: "Une erreur est survenue lors de l'enregistrement.",
        });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <DuoModal
      title="Ajouter un poste"
      onClose={handleClose}
      footer={
        <>
          <button type="button" className="duo-btn duo-btn--ghost" onClick={handleClose} disabled={isLoading}>
            Annuler
          </button>
          <button type="submit" form="add-poste-form" className="duo-btn duo-btn--primary" disabled={isLoading}>
            {isLoading ? 'Enregistrement...' : 'Enregistrer'}
          </button>
        </>
      }
    >
      <form id="add-poste-form" onSubmit={handleSubmit}>
        <div className="duo-form-group">
          <label htmlFor="add-poste-titre" className="duo-form-label">
            Titre du poste *
          </label>
          <input
            type="text"
            className="duo-input"
            id="add-poste-titre"
            name="titre"
            value={formData.titre}
            onChange={handleChange}
          />
          {errors.titre && <p className="text-danger small mt-1 mb-0">{errors.titre[0]}</p>}
        </div>
        <div className="duo-form-group">
          <label htmlFor="add-poste-description" className="duo-form-label">
            Description
          </label>
          <textarea
            className="duo-input"
            id="add-poste-description"
            name="description"
            rows={3}
            value={formData.description}
            onChange={handleChange}
          />
          {errors.description && <p className="text-danger small mt-1 mb-0">{errors.description[0]}</p>}
        </div>
        <div className="duo-form-group mb-0">
          <label className="duo-form-label d-flex align-items-start gap-2">
            <input
              type="checkbox"
              className="form-check-input mt-1"
              name="statut"
              checked={formData.statut}
              onChange={handleChange}
            />
            <span>
              Poste actif
              <span className="d-block fw-normal" style={{ fontSize: '0.78rem', color: '#777' }}>
                Décochez pour rendre le poste inactif.
              </span>
            </span>
          </label>
        </div>
      </form>
    </DuoModal>
  );
}
